import axios from "axios";

export const login = (user) => {
  return axios.post("/api/v1/login", {}, { auth: user });
};
export const setAuthorizationHeader = ({ username, password, isLoggedIn }) => {
  if (isLoggedIn) {
    axios.defaults.headers["Authorization"] = `Basic ${btoa(
      username + ":" + password
    )}`;
  } else {
    delete axios.defaults.headers["Authorization"];
  }
};
